/* @flow */

export const FETCH_MEMBERSHIP_REQUEST = 'FETCH_MEMBERSHIP_REQUEST';
export const FETCH_MEMBERSHIP_SUCCESS = 'FETCH_MEMBERSHIP_SUCCESS';
export const FETCH_MEMBERSHIP_FAILURE = 'FETCH_MEMBERSHIP_FAILURE';

export const PATCH_MEMBERSHIP_REQUEST = 'PATCH_MEMBERSHIP_REQUEST';
export const PATCH_MEMBERSHIP_SUCCESS = 'PATCH_MEMBERSHIP_SUCCESS';
export const PATCH_MEMBERSHIP_FAILURE = 'PATCH_MEMBERSHIP_FAILURE';

export const RESET_MEMBERSHIP = 'RESET_MEMBERSHIP';

export const FETCH_CALENDAR_SYNC_STATUS_REQUEST =
  'FETCH_CALENDAR_SYNC_STATUS_REQUEST';
export const FETCH_CALENDAR_SYNC_STATUS_SUCCESS =
  'FETCH_CALENDAR_SYNC_STATUS_SUCCESS';
export const FETCH_CALENDAR_SYNC_STATUS_FAILURE =
  'FETCH_CALENDAR_SYNC_STATUS_FAILURE';

export const FETCH_GUIDANCE_MARKET_PROMPT_REQUEST =
  'FETCH_GUIDANCE_MARKET_PROMPT_REQUEST';
export const FETCH_GUIDANCE_MARKET_PROMPT_SUCCESS =
  'FETCH_GUIDANCE_MARKET_PROMPT_SUCCESS';
export const FETCH_GUIDANCE_MARKET_PROMPT_FAILURE =
  'FETCH_GUIDANCE_MARKET_PROMPT_FAILURE';

export const DELETE_GUIDANCE_MARKET_PROMPT_REQUEST =
  'DELETE_GUIDANCE_MARKET_PROMPT_REQUEST';
export const DELETE_GUIDANCE_MARKET_PROMPT_SUCCESS =
  'DELETE_GUIDANCE_MARKET_PROMPT_SUCCESS';
export const DELETE_GUIDANCE_MARKET_PROMPT_FAILURE =
  'DELETE_GUIDANCE_MARKET_PROMPT_FAILURE';
